<template>
  <div class="com-sessionLab">
    <div class="headBox">
      <span class="headBox-title">{{Language('会话标签')}}</span>
      <span class="headBox-val">{{selectedList}}</span>
    </div>
    <div class="searchInput">
      <span style="display:inline-block;vertical-align: middle;margin-right:10px;">{{Language('搜索标签')}}</span>
      <el-cascader v-show="labelActive==1" placeholder="" :options="optionsList" :props="props" filterable style="width: 220px;"
      @change="handleChangeFn" v-model="selectedLablist"></el-cascader>
      <el-input v-show="labelActive==2" placeholder="" v-model="searchVal" @input="handleSearchFn" style="width: 220px;margin-top: 10px;"></el-input>
    </div>
    <div class="labelListBox">
      <el-tabs class="notRight tabs-title labelList" v-model="labelActive" tab-position="top">
        <el-tab-pane :label="Language('普通标签')" name="1">
          <el-cascader-panel v-if="labelActive==1" v-model="selectedLablist" :options="optionsList" @change="handleChangeFn" :props="props" ref="myCascader"></el-cascader-panel>
        </el-tab-pane>
        <el-tab-pane :label="Language('热点标签')" name="2">
          <el-checkbox-group class="hotLabelBox" v-model="hotSelected" size="small">
            <el-checkbox class="hotLabelItem" v-for="item in hotPointList" :key="item.id" border :label="item.labName+item.id" @change="hotLabelFn($event, item)">
              <span>{{item.labName}}</span>
              <span :title="item.namePath">{{item.namePath}}</span>
            </el-checkbox>
          </el-checkbox-group>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="btnList">
      <p class="pt-5 mr-10 fl">备注信息</p>
      <el-input v-model="remark" placeholder="" size="small" maxlength="500" show-word-limit class="fl" style="width: calc(100% - 215px);"></el-input>
      <el-button size="small" @click="handleComitFn(2)">{{Language('取 消')}}</el-button>
      <el-button size="small" type="primary" @click="handleComitFn(1)">{{Language('确 定')}}</el-button>
    </div>
  </div>
</template>

<script>
import { sessionLabData, sessionLabMethod } from "./js/SessionLab.js"

export default {
  name: "SessionLab",
  components: {},
  props: ['sessLabPath', 'pageType'],
  data() {
    return{
      ...sessionLabData
    }
  },
  watch:{
    "sessLabPath": {
      handler(val, oldVal){
        this.labelActive = '2'
        this.formatHotLab(2)
      },
      deep: true
    },
    labelActive(val) {
      const self = this
      if (val == '1') {
        self.formatHotLab(1)
        $('.labelListBox .el-tabs__active-bar').css('transform', 'translateX(0)')
      }
      if (val == '2') {
        self.searchVal = ''
        self.hotPointList = self.hotPointListBak
        self.formatHotLab(2)
        $('.labelListBox .el-tabs__active-bar').css('transform', 'translateX(80px)')
      }
    }
  },  
  created() {
    const self = this
    self.fetchSessionLableList()
    self.fetchHotPointList()
  },
  mounted() {
    const self = this
    $(function() {
      $('.labelListBox .el-tabs__active-bar').css('transform', 'translateX(80px)')
      $('.el-cascader .el-input__suffix').remove()
      $('.el-cascader .el-cascader__search-input').focus(function() {
        $('.el-cascader__dropdown .el-cascader-panel').remove()
      })
    })
  },
  methods: {
    ...sessionLabMethod
  }
}
</script>

<style lang="scss">
  .com-sessionLab{
    .notRight{ height: 100% }
    .el-tag--info{
      display: none !important;
    }
    .el-cascader{
      margin-top: 10px;
    }
    .el-cascader,
    .el-cascader .el-input .el-input__inner{
      height: 32px !important;
      line-height: 32px !important;
    }
    .el-input-group__append{
      padding: 0 12px;
    }
    .el-cascader-panel{
      height: 100%;
      overflow-x: auto;
    }
    .el-cascader-menu{
      min-width: 250px;
    }
    .el-cascader-menu,
    .el-scrollbar__wrap{
      height: 100%;
    }
    .el-scrollbar__wrap{
      overflow: auto;
    }
    .el-cascader-node{
      padding: 0 10px;
    }
    .labelListBox{
      height: calc(100% - 140px);
    }
    .labelList{
      height: 100%;
      .el-tabs__nav{
        padding: 0 !important;
      }
      .el-tabs__item{
        margin: 0 !important;
        padding: 0 !important;
        text-align: center;
        width: 80px !important;
      }
      .el-tabs__active-bar{
        margin: 0 0 0 10px !important;
        padding: 0 !important;
        text-align: center;
        width: 60px !important;
      }
      .el-tabs__content .el-tab-pane{
        height: 99% !important;
      }
      .el-checkbox.is-bordered.is-checked{
        border: 1px solid #DCDFE6;
      }
    }
    .hotLabelBox{
      height: 100%;
      overflow-y: auto;
    }
    .hotLabelItem{
      margin: 0 7px 10px 0 !important;
      width: calc(100% / 3 - 7px);
      height: auto !important;
      .el-checkbox__input,
      .el-checkbox__label{
        display: inline-block;
        vertical-align: middle;
      }
      .el-checkbox__label{
        width: calc(100% - 25px);
        span{
          display: block;
          white-space:nowrap;
          text-overflow:ellipsis;
          overflow:hidden;
        }
      }
      &:nth-child(3n) {
        margin-right: 0 !important;
      }
    }
  }
  .labelListBox{
    .el-checkbox__inner{
      width: 12px !important;
      height: 12px !important;
    }
    .el-checkbox__inner::after{
      top: 0;
    }
    .el-cascader-node__label{
      font-size: 12px;
    }
  }
</style>
<style scoped lang="scss">
  .com-sessionLab{
    padding: 0 20px;
    height: 100%;
    .headBox{
      .headBox-title{
        display: inline-block;
        vertical-align: middle;
        width: 70px;
      }
      .headBox-val{
        border: 1px solid #ECECEC;
        text-indent: 10px;
        padding: 3px 0px;
        display: inline-block;
        vertical-align: middle;
        margin-left: -5px;
        width: calc(100% - 72px);
        min-height: 40px;
        max-height: 40px;
        overflow-y: auto;
      }
    }
    .btnList{
      padding: 10px 0 0;
      text-align: right;
    }
  }
</style>
<style lang="scss">
.labelListBox .el-tabs__content{
  height: calc(100% - 55px);
}
</style>


// WEBPACK FOOTER //
// SessionLab.vue?0a193ffb